import { render, staticRenderFns } from "./RedBlueCombat.vue?vue&type=template&id=969711f4&scoped=true"
import script from "./RedBlueCombat.vue?vue&type=script&lang=js"
export * from "./RedBlueCombat.vue?vue&type=script&lang=js"
import style0 from "./RedBlueCombat.vue?vue&type=style&index=0&id=969711f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969711f4",
  null
  
)

export default component.exports